<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div class="bodyTitle">
      <app-survey-frame-list>
        <app-survey-frame-tab-template
          #tabs
          [headerTemplate]="headerTemplate"
          [bodyTemplate]="bodyTemplate"
          [contexts]="contexts"
          headerWidth="40%"
          bodyWidth="55%"
          (tabChange)="forceReloadTab()"
        >
        </app-survey-frame-tab-template>
      </app-survey-frame-list>
    </div>
  </div>
</div>
<ng-template #headerTemplate let-index="index" let-building="building">
  <mat-icon style="color: red" *ngIf="getErrors(building.id)">warning</mat-icon>
  <div class="templateHeader building">
    <span class="building-key">
      <span class="bold landscape">
        <span i18n="@@general.units.building"> Building </span>
        {{ index + 1 }}
      </span>
      <span class="bold portrait">B{{ index + 1 }}</span>
      <span class="key" *ngIf="building?.lomKey">
        - {{ building?.lomKey }}
      </span>
    </span>
    <span class="address">{{
      building?.getMainAddress()?.getFullAddress()
    }}</span>
    <span class="type"
      >{{ buildingTypeEnum[building.buildingType]
      }}<span *ngIf="building.buildingType == buildingTypeEnum.StudentHome"
        >({{ building.studentHomeCount }})</span
      ></span
    >
  </div>
</ng-template>
<ng-template #bodyTemplate let-index="index" let-building="building">
  <div>
    <div class="section" *ngIf="unitForms[building.id]">
      <form class="units-form" [formGroup]="unitForms[building.id]">
        <div class="flex-row">
          <div class="column">
            <div class="sub-title required" i18n="@@general.floors">Floors</div>
            <div
              class="form-line unit-info"
              *ngIf="componentReload"
              [ngClass]="{
                'invalid-answer-input': getErrors(
                  building.id,
                  insideSurveyOutsideUnits.FLOORS_FIELD
                )
              }"
            >
              <app-unit-info
                *ngFor="let floorQuestion of floorQuestions"
                [isDisabled]="!isAuthCanWrite"
                [unitType]="floorQuestion.label"
                [minValue]="0"
                [maxValue]="100"
                [formControl]="unitForms[building.id].get(floorQuestion.key)"
                (currentValueChange)="
                  onQuantityChange($event, floorQuestion.key, building.id)
                "
              >
              </app-unit-info>
            </div>
            <div class="form-line">
              <span i18n="@@general.mduflag" class="question"> MDu Flag </span>
              <p-checkbox
                binary="true"
                [disabled]="true"
                formControlName="checkbox"
              ></p-checkbox>
            </div>
            <div class="sub-title required subtitle-wrapper">
              <mat-icon
                style="color: red"
                *ngIf="
                  getErrors(
                    building.id,
                    insideSurveyOutsideUnits.BUILDING_CHARACTERISTIC_FIELD
                  )
                "
                >warning
              </mat-icon>
              <div i18n="@@general.buildingtype">Building Characteristic</div>
            </div>
            <div
              class="form-line"
              [ngClass]="{
                'invalid-answer-input': getErrors(
                  building.id,
                  insideSurveyOutsideUnits.BUILDING_CHARACTERISTIC_FIELD
                )
              }"
            >
              <div class="select-wrapper">
                <p-dropdown
                  [options]="buildingTypeOptions"
                  [disabled]="!this.isAuthCanWrite"
                  formControlName="buildingType"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="_"
                  (onShow)="buildingTypesDuringInsideSurvey()"
                ></p-dropdown>
              </div>
            </div>
            <ng-container
              *ngIf="
                unitForms[building.id].get('buildingType')?.value ==
                buildingTypeEnum.StudentHome
              "
            >
              <div class="sub-title required" i18n="@@general.units.nrofRooms">
                The number of rooms
              </div>
              <div class="form-line">
                <div class="input-wrapper">
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    [disabled]="!this.isAuthCanWrite"
                    [formControlName]="'building' + studentHomeCountKey"
                  />
                </div>
              </div>
            </ng-container>
          </div>
          <div class="column">
            <div class="sub-title required subtitle-wrapper">
              <mat-icon
                style="color: red"
                *ngIf="
                  getErrors(building.id, insideSurveyOutsideUnits.UNITS_FIELD)
                "
                >warning
              </mat-icon>
              <div class="sub-title" i18n="@@general.units">
                Units (initial)
              </div>
            </div>
            <div
              class="form-line unit-info"
              *ngFor="let unitInfoQuestion of unitQuestions"
              [ngClass]="{
                'invalid-answer-input': getErrors(
                  building.id,
                  insideSurveyOutsideUnits.UNITS_FIELD
                )
              }"
            >
              <ng-container *ngIf="componentReload">
                <app-unit-info
                  [isDisabled]="!isAuthCanWrite"
                  [unitType]="unitInfoQuestion.label"
                  [minValue]="0"
                  [maxValue]="1000"
                  [originalValue]="unitInfoQuestion.originalValue"
                  [formControl]="
                    unitForms[building.id].get(unitInfoQuestion.key)
                  "
                  (currentValueChange)="
                    onQuantityChange($event, unitInfoQuestion.key, building.id)
                  "
                >
                </app-unit-info>
              </ng-container>
            </div>
            <div class="totalUnitFrame">
              <div i18n="@@general.totalUnits" class="question">
                Total Units
              </div>
              <div>
                {{ calculateTotalUnitsForBuilding(building) }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="section address-section">
      <div *ngFor="let address of building.addresses; let i = index">
        <app-survey-frame-list>
          <app-survey-frame-list-template [index]="100 + i" [id]="address.id">
            <div
              class="templateHeader"
              header
              (click)="addressTypesForBuilding(building)"
            >
              <span class="building-key">
                <mat-icon
                  style="color: red; margin-right: 0.5rem"
                  *ngIf="getErrors(building.id, address.id)"
                  >warning
                </mat-icon>
                <span class="bold">
                  <span i18n="@@general.units.address">Address</span>
                  {{ i + 1 }}
                </span>
                <span class="key" *ngIf="address.lomKey">
                  - {{ address.lomKey }}
                </span>
              </span>
              <span class="address">
                {{ address.getFullAddress() }}
              </span>
              <span class="type">{{
                addressTypeEnum[address.addressType]
              }}</span>
            </div>
            <div detail>
              <div class="section">
                <form class="units-form" [formGroup]="unitForms[building.id]">
                  <div class="flex-row">
                    <div class="column">
                      <div
                        class="sub-title required"
                        i18n="@@general.addresstype"
                      >
                        Address Characteristic
                      </div>
                      <div class="form-line">
                        <div class="select-wrapper">
                          <p-dropdown
                            [options]="addressTypeOptions"
                            [formControlName]="addressTypeKey + i"
                            [disabled]="!this.isAuthCanWrite"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="_"
                            appendTo="body"
                            (onShow)="addressTypesForBuilding(building)"
                          ></p-dropdown>
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <ng-container
                        *ngIf="
                          unitForms[building.id].get(addressTypeKey + i)
                            ?.value == addressTypeEnum.StudentHome
                        "
                      >
                        <div class="sub-title subtitle-wrapper">
                          <mat-icon
                            style="color: red"
                            *ngIf="
                              getErrors(
                                building.id,
                                address.id,
                                insideSurveyOutsideUnits.NUMBER_OF_ROOMS_FIELD
                              )
                            "
                            >warning
                          </mat-icon>
                          <div
                            class="sub-title required"
                            i18n="@@general.units.nrofRooms"
                          >
                            The number of rooms
                          </div>
                        </div>
                        <div
                          class="form-line"
                          [ngClass]="{
                            'invalid-answer-input': getErrors(
                              building.id,
                              address.id,
                              insideSurveyOutsideUnits.NUMBER_OF_ROOMS_FIELD
                            )
                          }"
                        >
                          <div class="input-wrapper">
                            <input
                              class="form-control"
                              type="number"
                              min="0"
                              [disabled]="!this.isAuthCanWrite"
                              [formControlName]="
                                'address' + address.id + studentHomeCountKey
                              "
                            />
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </app-survey-frame-list-template>
        </app-survey-frame-list>
      </div>
    </div>
  </div>
</ng-template>
